import { redirectTo, routeLoader } from "router/loaders";
import { CatalogPage } from "views/page-content/CatalogPage";
import { CatalogCustomizationPage } from "views/page-content/CatalogPage/CatalogCustomizationPage";
import { CatalogGatingOptionsPage } from "views/page-content/CatalogPage/CatalogGatingOptionsPage";
import { CollectionCustomizationPage } from "views/page-content/CatalogPage/CollectionPage/CollectionCustomizationPage";
import { CollectionFeaturedTrailerPage } from "views/page-content/CatalogPage/CollectionPage/CollectionFeaturedTrailerPage";
import { CollectionGatedContentPage } from "views/page-content/CatalogPage/CollectionPage/CollectionGatedContentPage";
import { CollectionLinksContentPage } from "views/page-content/CatalogPage/CollectionPage/CollectionLinksContentPage";
import { CollectionPage } from "views/page-content/CatalogPage/CollectionPage";
import { FeaturedTrailerPage } from "views/page-content/CatalogPage/FeaturedTrailerPage";
import { CollectionVideoDetailsPage } from "views/page-content/VideoDetailsPage/CollectionVideoDetailsPage";

const catalogRouteData = {
    badgeConfig: {
        claimCheck: false,
        claim: "videoplayer",
        label: "preview",
        class: "badge-preview"
    },
    upgradeConfig: {
        claimCheck: false,
        claim: "videoplayer",
        label: "upgrade-business"
    }
};

export const CatalogRoutes = [
    {
        path: "catalog",
        element: <CatalogPage />
    },
    {
        path: "catalog/featured-trailer",
        element: <FeaturedTrailerPage />
    },
    {
        path: "catalog/customization",
        element: <CatalogCustomizationPage />
    },
    {
        path: "catalog/catalog-subscription",
        element: <CatalogGatingOptionsPage />
    },
    {
        path: "catalog/collections",
        loader: redirectTo("/catalog")
    },
    {
        path: "catalog/collections/:videoPlayerId",
        element: <CollectionPage />,
        loader: routeLoader({
            data: catalogRouteData
        })
    },
    {
        path: "catalog/collections/:videoPlayerId/gated-content",
        element: <CollectionGatedContentPage />,
        loader: routeLoader({
            data: catalogRouteData
        })
    },
    {
        path: "catalog/collections/:videoPlayerId/featured-trailer",
        element: <CollectionFeaturedTrailerPage />,
        loader: routeLoader({
            data: catalogRouteData
        })
    },
    {
        path: "catalog/collections/:videoPlayerId/links",
        element: <CollectionLinksContentPage />,
        loader: routeLoader({
            data: catalogRouteData
        })
    },
    {
        path: "catalog/collections/:videoPlayerId/customization",
        element: <CollectionCustomizationPage />,
        loader: routeLoader({
            data: catalogRouteData
        })
    },
    {
        path: "catalog/collections/:videoPlayerId/video/:playlistBroadcastId",
        element: <CollectionVideoDetailsPage />,
        loader: routeLoader({
            data: catalogRouteData
        })
    }
];
